import type { User } from '@lmc/ts-common'
import { Avatar } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type TeamMemberCardProps = {
  user: User
}

const TeamMemberCard = ({ user }: TeamMemberCardProps) => {
  return (
    <Container>
      <Avatar size={28} url={user.picture as unknown as string} />
      <Text weight="bold">{`${user.name?.first} ${user.name?.last}`}</Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.color.neutral.color3};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.status.primary};
  }
`

export default TeamMemberCard
